import { tokenBlackList } from 'config/constants/tokens';
import { Token } from 'config/types';

export const isSolToken = (token: Token) => {
  // return token?.network === ChainIdEnum.SOL || token?.network === ChainIdEnum.SOL_TESTNET // INTERGRATE SOLANA
  return false;
};

export const validateTokenBlackList = (token: Token): boolean => token && !!tokenBlackList.includes(token);
